export const getTokens = (resp) => ({
  accessToken: resp.accessToken,
  refreshToken: resp.refreshToken,
  idToken: resp.idToken,
});
